export interface NationalIdState {
  nationalIdType: NationalIdType;
  nationalIdFrontBlob?: Blob;
  nationalIdBackBlob?: Blob;
}

export enum NationalIdType {
  OLD = "OLD",
  NEW = "NEW",
}

export enum DocumentSide {
  FRONT = "FRONT",
  BACK = "BACK",
  DUAL = "DUAL",
}

export interface NewNationalIdPayload extends FormData {
  applicantId?: string;
  publicKey?: string;
  file?: string;
  back?: string;
  backIsPrimary: boolean;
  type?: DocumentType;
  side?: DocumentSide;
  iso2CountryCode?: string;
  taxId?: string;
}
